
import CurrentUserService from '@/services/currentUserService';
import { Vue } from 'vue-class-component';

export default class Workbench extends Vue {
   private name = CurrentUserService.GetUserInfo().name;

   go(routeName:string) :void {
     this.$router.push(routeName);
   }
}
